import { useTranslation } from "react-i18next";

import { RECALL_ENTITY_STATUSSES } from "models";

import type { RecallEntity } from "models";

export const useGetDistrimateRecallStatusName = () => {
  const { t } = useTranslation();

  const getDistrimateRecallStatusName = (status: RECALL_ENTITY_STATUSSES) => {
    switch (status) {
      case RECALL_ENTITY_STATUSSES.Settled:
        return t("v8_settled", "Settled");
      case RECALL_ENTITY_STATUSSES.Unsettled:
        return t("v8_unsettled", "Unsettled");
      case RECALL_ENTITY_STATUSSES.Unsupported:
        return t("v8_unsupported", "Unsupported");
    }
  };

  return { getDistrimateRecallStatusName };
};

export const retrieveOpenRecalls = (recalls: RecallEntity[] | undefined = []) => {
  return recalls.filter(recall => recall.status === RECALL_ENTITY_STATUSSES.Unsettled);
};
